import {PortfolioActivity} from '#/components/portfolio/sections/portfolio-activity';
import {PortfolioAssets} from '#/components/portfolio/sections/portfolio-assets';
import {PortfolioWishlist} from '#/components/portfolio/sections/portfolio-wishlist';
import {PortfolioIconTitle} from '#/components/portfolio/subcomponents/portfolio-icon-title';
import {useQueryParamsTabKey} from '#/hooks/use-query-params-tab';
import {PortfolioTab} from '#/navigation/tabs';
import {ClassName} from '#/utils/utils';
import {BanknotesIcon, ClockIcon, StarIcon} from '@heroicons/react/24/solid';
import * as Tabs from '@radix-ui/react-tabs';
import {FunctionComponent} from 'react';
import {useTranslation} from 'react-i18next';

export const PortfolioTabs: FunctionComponent<ClassName> = ({className}) => {
  const {t} = useTranslation('translation');

  const {tab, setTab} = useQueryParamsTabKey({queryParamTabKey: 'portfolioTabId', tabKeys: PortfolioTab});
  const onValueChange = (value: string) => {
    setTab(value as PortfolioTab);
  };

  return (
    <Tabs.Root className={className} value={tab} onValueChange={onValueChange} {...({} as any)}>
      <Tabs.List
        className={
          'flex gap-6 bg-grayblue overflow-hidden sticky top-0 left-0 z-20 pt-4 sm:pt-8 pb-5 overflow-x-scroll'
        }
        {...({} as any)}
      >
        <TabsTrigger value={PortfolioTab.ASSETS} IconComponent={BanknotesIcon}>
          {t('pages.portfolio.sections.assets.title')}
        </TabsTrigger>
        <TabsTrigger value={PortfolioTab.WATCHLIST} IconComponent={StarIcon}>
          {t('pages.portfolio.sections.watchlist.title')}
        </TabsTrigger>
        <TabsTrigger value={PortfolioTab.ACTIVITY} IconComponent={ClockIcon}>
          {t('pages.portfolio.sections.activity.title')}
        </TabsTrigger>
      </Tabs.List>

      <TabsContent value={PortfolioTab.ASSETS} {...({} as any)}>
        <PortfolioAssets />
      </TabsContent>

      <TabsContent value={PortfolioTab.WATCHLIST} {...({} as any)}>
        <PortfolioWishlist />
      </TabsContent>

      <TabsContent value={PortfolioTab.ACTIVITY} {...({} as any)}>
        <PortfolioActivity />
      </TabsContent>
    </Tabs.Root>
  );
};

const TabsTrigger = ({IconComponent, value, children, ...rest}) => (
  <Tabs.Trigger
    className='flex items-center gap-2 px-0 pb-1 border-b-4 border-transparent data-[state=active]:border-white transition-all duration-300'
    value={value}
    {...(rest as any)}
  >
    <PortfolioIconTitle IconComponent={IconComponent}>{children}</PortfolioIconTitle>
  </Tabs.Trigger>
);

const TabsContent = ({value, children, className, ...rest}) => (
  <Tabs.Content className='w-full pb-5 md:pb-10' value={value} {...(rest as any)}>
    {children}
  </Tabs.Content>
);
